import { render, staticRenderFns } from "./oridepman.vue?vue&type=template&id=a5133c4a&scoped=true&"
import script from "./oridepman.vue?vue&type=script&lang=js&"
export * from "./oridepman.vue?vue&type=script&lang=js&"
import style0 from "./oridepman.vue?vue&type=style&index=0&id=a5133c4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5133c4a",
  null
  
)

export default component.exports